/**
 * The company that owns and sells ERP PRO, as the screens show it. Kept the same as
 * packages/core/src/vendor.ts (the browser does not load the server's code).
 */
export const VENDOR = {
  legal_name: 'BlackAtlas Global LLC',
  website: 'www.blackatlas.biz',
  product: { website: 'erp-pro.biz', email: 'info@erp-pro.biz' },
} as const;
